import { html } from "gridjs";
import { currencyCode, currencyCodeLocale } from "../../utils/locale";
import isbot from "isbot";

function cleanURL(url) {
  return url.split('/').slice(0,-2).join('/') + '/'
}

// Returns false if user agent is a bot
const enablePagination = () => {
  return !isbot(navigator.userAgent)
}

// Exported so that it can be overridden at the table level. Is it a good idea?
export const GRIDJS_CURRENCY = {
  'code': currencyCode,
  'locale': currencyCodeLocale
};

export const GRIDJS_CONFIGS = [];
GRIDJS_CONFIGS['vintage_perf'] = {
  columns: [
    {
      name: 'id',
      hidden: true,
    },
    {
      name: 'usedForSearch',
      hidden: true,
    },
    getTranslatedString('wine', 'Wine'),
    getTranslatedString('vintage', 'Vintage'),
    {
      name: getTranslatedString('high_score', 'Highest score'),
      formatter: (cell, row) => cell > 0 ? cell : 'N/A',
    },
    {
      name: getTranslatedString('pop_score', 'Pop score'),
      formatter: (cell, row) => cell > 0 ? cell : 'N/A',
    },
    {
      name: getTranslatedString('price', 'Price'),
      formatter: (cell, row) => {
        if(parseInt(cell) === 0){
          return 'POA'
        }
        const formattedValue = new Intl.NumberFormat(GRIDJS_CURRENCY.locale, {
          style: 'currency',
          currency: GRIDJS_CURRENCY.code,
          minimumFractionDigits: 0}).format(cell);
        return `${formattedValue} (${row.cells[7].data})`
      },
    },
    {
      name: 'Unit Size',
      hidden: true,
    },
    {
      id: 'link',
      name: '',
      sort: false,
      formatter: (cell, row) => {
        const wineName = row.cells[2].data;
        const vintageYear = row.cells[3].data;

        return html(
          `<a title="${wineName}, ${vintageYear}" href="${cell}" class="gridjs-tr__table-link">
                   <span class="visually-hidden">Learn about ${wineName}, ${vintageYear}</span>
                 </a>`);
      },
    }
  ],
  server: {
    url: '',
    then: data => data.map(
      vintage => [
        vintage.id,
        cleanURL(vintage.link),
        vintage.wine_name,
        vintage.year,
        vintage.high_score,
        vintage.pop_score,
        vintage.price,
        vintage.unit_size,
        vintage.link
      ])
  },
  sort: true,
  pagination: {
    enabled: enablePagination(),
    limit: 6,
    summary: false
  },
  search: {
    enabled: true,
    selector: (cell, rowIndex, cellIndex) => cellIndex === 0 ? cell.usedForSearch : cell,
  },
};

GRIDJS_CONFIGS['wine_price_list'] = {
  columns: [
    {
      name: 'id',
      hidden: true,
    },
    {
      name: 'Wine',
      width: '30%',
    },
    getTranslatedString('vintage', 'Vintage'),
    getTranslatedString('region', 'Region'),
    {
      name: getTranslatedString('unit_price', 'Unit price'),
      formatter: (cell, row) => {
        const formattedValue = new Intl.NumberFormat(GRIDJS_CURRENCY.locale, {
          style: 'currency',
          currency: GRIDJS_CURRENCY.code,
          minimumFractionDigits: 2}).format(cell);
        return `${formattedValue}`
      },
    },
    getTranslatedString('unit_size', 'Unit size'),
    {
      id: 'link',
      name: '',
      sort: false,
      formatter: (cell, row) => {
        const wineName = row.cells[1].data;
        const region = row.cells[2].data;

        return cell ? html(
          `<a href="${cell}" class="gridjs-tr__table-link" title="${wineName}, ${region}">
         <span class="visually-hidden">${wineName}, ${region}</span>
       </a>`) : '';
      },
    }
  ],
  server: {
    url: '',
    then: data => data.map(
      priceItem => [
        priceItem.id,
        priceItem.wine_name,
        priceItem.year,
        priceItem.region,
        priceItem.price,
        priceItem.unit_size,
        priceItem.link,
      ])
  },
  sort: true,
  pagination: {
    enabled: true,
    limit: 40,
    summary: false
  },
  search: {
    enabled: true,
  },
  language: {
    'search': {
      'placeholder': getTranslatedString('search_placeholder', 'Search by wine, region, year...')
    },
  }
};

/**
 * Try to get a translated string from data output by SS - a bit lame...
 * @param key
 * @param defaultValue
 * @returns {string|*|string}
 */
function getTranslatedString(key, defaultValue = '') {
  if (typeof i18nTableCols !== 'undefined') {
    // eslint-disable-next-line no-undef
    return (key in i18nTableCols) ? i18nTableCols[key] : defaultValue;
  }
  return defaultValue;
}
